import React, { useEffect, useState } from 'react';
import { Check, Shield, BookOpen, Clock, Star, AlertCircle, ChevronDown, Lock, X } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
// Image URLs
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/6qrrKJBNLbZo3x9zPgBFbW/PROYECTOS_Anuales_(5).png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/innVMTkTCmJ4eQoJahCdgb/31.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/4HkkRvsjcK6FDMmMdQETVT/32.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/2qUaHoCzFsrqL3YNug2J72/33.png';
const BONUS_4_IMAGE = 'https://cdn.magicpatterns.com/uploads/e9fHiiPS7Dog4VGPUckNpr/34.png';
const BONUS_5_IMAGE = 'https://cdn.magicpatterns.com/uploads/uzUyoxyGB6KMJwCNr53DN1/35.png';
function CountdownTimer() {
  const [time, setTime] = useState({
    minutes: 14,
    seconds: 54
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prevTime => {
        if (prevTime.seconds > 0) {
          return {
            ...prevTime,
            seconds: prevTime.seconds - 1
          };
        } else if (prevTime.minutes > 0) {
          return {
            minutes: prevTime.minutes - 1,
            seconds: 59
          };
        }
        return prevTime;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-red-600 text-white py-1.5 px-4 text-center font-bold text-[10px] md:text-xs" data-id="element-21">
      <div className="max-w-6xl mx-auto" data-id="element-22">
        <span data-id="element-23">
          ⏳ OFERTA EXPIRA EN: {String(time.minutes).padStart(2, '0')}:
          {String(time.seconds).padStart(2, '0')} | 🔥 SOLO QUEDAN 3 CUPOS
        </span>
      </div>
    </div>;
}
export function LandingPage() {
  const checkoutUrl = 'https://checkout13.edulabs.online/cart/44682428743816:1';
  const testimonials = [{
    name: 'María González',
    role: 'Profesora de Matemática',
    location: 'Buenos Aires',
    content: 'Antes pasaba horas buscando material. Ahora entro a clase con todo listo.'
  }, {
    name: 'Carlos Ramírez',
    role: 'Docente de Secundaria',
    location: 'Madrid',
    content: 'Me ahorró muchísimo tiempo. En minutos tengo la clase armada.'
  }, {
    name: 'Ana Martínez',
    role: 'Profesora de Matemática',
    location: 'México',
    content: 'Mis alumnos entienden más y yo explico con más seguridad.'
  }, {
    name: 'José López',
    role: 'Profesor de Bachillerato',
    location: 'Bogotá',
    content: 'En 20 años de docencia, es el recurso más completo que usé.'
  }, {
    name: 'Laura Fernández',
    role: 'Profesora ESO',
    location: 'Santiago',
    content: 'No es teoría vacía. Es práctica real que funciona en el aula.'
  }];
  const faqs = [{
    q: '¿Es material digital?',
    a: 'Sí. Acceso y descarga inmediata.'
  }, {
    q: '¿Sirve para cualquier nivel educativo?',
    a: 'Sí. Cubre de 1° a 6° año (Secundaria / Bachillerato / ESO).'
  }, {
    q: '¿Funciona para clases presenciales y online?',
    a: 'Sí, es totalmente adaptable.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No. Todo está explicado paso a paso.'
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-24">
      <PurchasePopup data-id="element-25" />
      <CountdownTimer data-id="element-26" />

      {/* Hero Section */}
      <header className="bg-white text-gray-900 pt-5 pb-5 px-4 text-center" data-id="element-27">
        <div className="max-w-4xl mx-auto" data-id="element-28">
          <p className="text-blue-600 font-bold text-lg mb-2" data-id="element-29">
            📐 Para docentes de Matemática
          </p>

          <h1 className="text-4xl md:text-6xl font-extrabold mb-2 leading-tight text-gray-900" data-id="element-30">
            MegaPack Matemática Lista
          </h1>

          <h2 className="text-xl md:text-2xl text-gray-700 mb-2 font-medium" data-id="element-31">
            Todo el material de Matemática que necesitás, listo para usar.
          </h2>

          <p className="text-lg text-gray-600 mb-1 max-w-2xl mx-auto" data-id="element-32">
            Clases claras, ordenadas y sin pasar horas planificando. Dejá de
            empezar desde cero cada semana.
          </p>

          <div className="mb-2" data-id="element-33">
            <a href={checkoutUrl} data-id="element-34">
              <img src={MAIN_IMAGE} alt="MegaPack Matemática LISTA" className="mx-auto max-w-full w-72 md:w-96 drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-35" />
            </a>
          </div>

          <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" className="text-sm md:text-base px-5 py-2.5 mb-2" scrollToPurchase={true} data-id="element-36" />

          <p className="text-sm text-gray-500" data-id="element-37">
            ✅ Garantía de satisfacción de 7 días
          </p>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-blue-50" data-id="element-38">
        <div className="max-w-3xl mx-auto" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8" data-id="element-40">
            Si enseñás Matemática, dejame hacerte una pregunta honesta
          </h2>

          <div className="bg-white rounded-lg p-8 shadow-md mb-8" data-id="element-41">
            <h3 className="text-2xl font-bold text-red-600 mb-4 text-center" data-id="element-42">
              ¿Te pasa que preparar la clase te cansa más que darla?
            </h3>

            <p className="text-lg text-gray-700 mb-4" data-id="element-43">
              No porque no sepas Matemática. No porque no seas buen docente.
            </p>

            <p className="text-lg text-gray-700 mb-4" data-id="element-44">
              Sino porque cada clase parece empezar desde cero.
            </p>

            <p className="text-lg text-gray-700 mb-4" data-id="element-45">
              Buscar ejercicios. Pensar problemas que se entiendan. Armar
              actividades. Preparar evaluaciones. Ordenar material suelto.
            </p>

            <p className="text-lg text-gray-700 font-semibold" data-id="element-46">
              Y cuando finalmente entrás al aula… ya estás cansado/a.
            </p>
          </div>

          <p className="text-2xl font-bold text-center text-blue-600" data-id="element-47">
            Enseñar Matemática no debería sentirse así.
          </p>
        </div>
      </section>

      {/* Problem List */}
      <section className="py-16 px-4 bg-white" data-id="element-48">
        <div className="max-w-3xl mx-auto" data-id="element-49">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-50">
            El problema que nadie dice en voz alta
          </h2>

          <p className="text-lg text-gray-700 mb-6 text-center" data-id="element-51">
            Si sos docente de Matemática, esto seguramente te resulta familiar:
          </p>

          <div className="bg-gray-50 rounded-lg p-8 space-y-4" data-id="element-52">
            {['Pasás horas planificando cada semana', 'Tenés material, pero está desordenado', 'Buscás ejercicios en mil lugares distintos', 'Guardás PDFs que después no encontrás', 'Terminás improvisando más de lo que te gustaría'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-53">
                <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-54" />
                <span className="text-lg text-gray-700" data-id="element-55">{item}</span>
              </div>)}
          </div>

          <div className="mt-8 bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg" data-id="element-56">
            <p className="text-lg text-gray-800 italic" data-id="element-57">
              Lo peor es esa sensación constante de:{' '}
              <strong data-id="element-58">
                "Podría dar mejores clases… si tuviera todo el material listo."
              </strong>
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-4 bg-blue-600 text-white text-center" data-id="element-59">
        <div className="max-w-4xl mx-auto" data-id="element-60">
          <h2 className="text-yellow-300 font-bold text-xl mb-4" data-id="element-61">
            ✅ LA SOLUCIÓN
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold mb-8" data-id="element-62">
            MegaPack Matemática Lista
          </h3>
          <p className="text-xl md:text-2xl mb-12 leading-relaxed" data-id="element-63">
            Un sistema completo de recursos de Matemática, organizado por año,
            diseñado para que dejes de improvisar y vuelvas a disfrutar enseñar.
          </p>

          <div className="grid md:grid-cols-3 gap-6 max-w-2xl mx-auto text-lg" data-id="element-64">
            <div className="bg-white/10 p-6 rounded-lg" data-id="element-65">
              <div className="text-4xl mb-3" data-id="element-66">📂</div>
              <p className="font-bold" data-id="element-67">Abrís el material</p>
            </div>
            <div className="bg-white/10 p-6 rounded-lg" data-id="element-68">
              <div className="text-4xl mb-3" data-id="element-69">👆</div>
              <p className="font-bold" data-id="element-70">Elegís el tema</p>
            </div>
            <div className="bg-white/10 p-6 rounded-lg" data-id="element-71">
              <div className="text-4xl mb-3" data-id="element-72">✏️</div>
              <p className="font-bold" data-id="element-73">Lo aplicás en clase</p>
            </div>
          </div>

          <p className="text-xl mt-8 font-semibold" data-id="element-74">
            Sin vueltas. Sin improvisar. Sin perder tiempo.
          </p>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 px-4 bg-white" data-id="element-75">
        <div className="max-w-4xl mx-auto" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-77">
            📘 ¿Qué incluye exactamente el MegaPack?
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-78">
            {['6 cuadernillos completos (1° a 6° año)', 'Teoría clara explicada paso a paso', 'Ejercicios resueltos', 'Actividades prácticas', 'Evaluaciones y diagnósticos', 'Secuencias didácticas por unidad', 'Material visual', 'Planillas docentes'].map((item, idx) => <div key={idx} className="flex items-start gap-3 bg-blue-50 p-4 rounded-lg" data-id="element-79">
                <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-80" />
                <span className="text-lg text-gray-800 font-medium" data-id="element-81">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-center text-lg text-gray-700 mb-8" data-id="element-82">
            Todo organizado para encontrar rápido lo que necesitás y cubrir todo
            el programa.
          </p>

          <div className="text-center" data-id="element-83">
            <CTAButton text="👉 ACCEDER CON DESCUENTO" className="text-xl px-12 py-6" scrollToPurchase={true} data-id="element-84" />
          </div>
        </div>
      </section>

      {/* Before vs After */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-85">
        <div className="max-w-5xl mx-auto" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-87">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-88">
            {/* Before */}
            <div className="bg-red-900/30 p-8 rounded-lg border-2 border-red-500" data-id="element-89">
              <h3 className="text-2xl font-bold mb-6 text-red-300" data-id="element-90">
                Antes del MegaPack
              </h3>
              <div className="space-y-4" data-id="element-91">
                {['Improvisación constante', 'Cansancio mental', 'Clases apuradas', 'Trabajo extra en casa', 'Estrés antes de cada clase'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-92">
                    <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-93" />
                    <span className="text-gray-200" data-id="element-94">{item}</span>
                  </div>)}
              </div>
            </div>

            {/* After */}
            <div className="bg-green-900/30 p-8 rounded-lg border-2 border-green-500" data-id="element-95">
              <h3 className="text-2xl font-bold mb-6 text-green-300" data-id="element-96">
                Después del MegaPack{' '}
                <span className="text-yellow-300" data-id="element-97">¡Mejor!</span>
              </h3>
              <div className="space-y-4" data-id="element-98">
                {['Clases claras y organizadas', 'Material listo siempre', 'Más seguridad al explicar', 'Menos trabajo fuera del aula', 'Más tranquilidad para enseñar'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-99">
                    <Check className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-100" />
                    <span className="text-gray-200" data-id="element-101">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-blue-50" data-id="element-102">
        <div className="max-w-6xl mx-auto" data-id="element-103">
          <div className="text-center mb-16" data-id="element-104">
            <h2 className="text-3xl md:text-5xl font-bold mb-4 text-gray-900" data-id="element-105">
              🎁 Regalos especiales
            </h2>
            <p className="text-2xl font-bold text-blue-600 mb-2" data-id="element-106">
              BONOS INCLUIDOS HOY
            </p>
            <p className="text-lg text-gray-600" data-id="element-107">(Sin costo adicional)</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-108">
            {/* Bonus 1 */}
            <a href={checkoutUrl} className="group" data-id="element-109">
              <div className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all h-full" data-id="element-110">
                <div className="relative mb-4" data-id="element-111">
                  <img src={BONUS_1_IMAGE} alt="Kit Premium de Evaluaciones" className="w-full rounded-lg" data-id="element-112" />
                  <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-bold px-4 py-2 rounded-md shadow-md" data-id="element-113">
                    GRATIS HOY
                  </div>
                </div>
                <div className="mb-3" data-id="element-114">
                  <p className="text-gray-400 line-through text-sm" data-id="element-115">
                    Valor: $19
                  </p>
                  <p className="text-green-600 font-bold text-lg" data-id="element-116">
                    HOY: GRATIS
                  </p>
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-117">
                  🎁 Bono #1 – Kit Premium de Evaluaciones
                </h3>
                <p className="text-gray-600" data-id="element-118">
                  +50 evaluaciones listas con criterios de corrección.
                </p>
              </div>
            </a>

            {/* Bonus 2 */}
            <a href={checkoutUrl} className="group" data-id="element-119">
              <div className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all h-full" data-id="element-120">
                <div className="relative mb-4" data-id="element-121">
                  <img src={BONUS_2_IMAGE} alt="Banco de Juegos" className="w-full rounded-lg" data-id="element-122" />
                  <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-bold px-4 py-2 rounded-md shadow-md" data-id="element-123">
                    GRATIS HOY
                  </div>
                </div>
                <div className="mb-3" data-id="element-124">
                  <p className="text-gray-400 line-through text-sm" data-id="element-125">
                    Valor: $15
                  </p>
                  <p className="text-green-600 font-bold text-lg" data-id="element-126">
                    HOY: GRATIS
                  </p>
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-127">
                  🎁 Bono #2 – Banco de Juegos y Actividades
                </h3>
                <p className="text-gray-600" data-id="element-128">
                  Más de 30 recursos lúdicos para motivar tus clases.
                </p>
              </div>
            </a>

            {/* Bonus 3 */}
            <a href={checkoutUrl} className="group" data-id="element-129">
              <div className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all h-full" data-id="element-130">
                <div className="relative mb-4" data-id="element-131">
                  <img src={BONUS_3_IMAGE} alt="Plantillas Profesionales" className="w-full rounded-lg" data-id="element-132" />
                  <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-bold px-4 py-2 rounded-md shadow-md" data-id="element-133">
                    GRATIS HOY
                  </div>
                </div>
                <div className="mb-3" data-id="element-134">
                  <p className="text-gray-400 line-through text-sm" data-id="element-135">
                    Valor: $12
                  </p>
                  <p className="text-green-600 font-bold text-lg" data-id="element-136">
                    HOY: GRATIS
                  </p>
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-137">
                  🎁 Bono #3 – Plantillas Profesionales de Planificación
                </h3>
                <p className="text-gray-600" data-id="element-138">
                  Modelos semanales y mensuales para organizar todo el año.
                </p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="purchase-section" className="py-20 px-4 bg-white scroll-mt-20" data-id="element-139">
        <div className="max-w-4xl mx-auto text-center" data-id="element-140">
          <div className="bg-yellow-100 border-2 border-yellow-500 rounded-lg p-4 mb-8 inline-block" data-id="element-141">
            <p className="text-xl font-bold text-gray-900" data-id="element-142">
              ⏰ Oferta por tiempo limitado
            </p>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-143">
            Accedé a MegaPack Matemática Lista
          </h2>
          <p className="text-xl text-blue-600 font-bold mb-8" data-id="element-144">
            + los 3 Bonos de regalo
          </p>

          <div className="bg-blue-50 rounded-lg p-8 max-w-2xl mx-auto mb-8" data-id="element-145">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-146">
              📦 Lo que vas a recibir hoy:
            </h3>
            <div className="text-left space-y-3 mb-8" data-id="element-147">
              {['6 cuadernillos de Matemática (1° a 6° año)', 'Bono #1: Kit Premium de Evaluaciones', 'Bono #2: Banco de Juegos y Actividades', 'Bono #3: Plantillas Profesionales de Planificación', 'Teoría clara + ejercicios resueltos', 'Actividades prácticas y material visual'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-148">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-149" />
                  <span className="text-gray-800" data-id="element-150">{item}</span>
                </div>)}
            </div>

            <div className="border-t-2 border-gray-300 pt-6 mb-6" data-id="element-151">
              <p className="text-red-500 line-through text-2xl font-bold mb-4" data-id="element-152">
                Precio regular: USD $49
              </p>
              <div className="mb-4" data-id="element-153">
                <p className="text-gray-700 font-semibold text-lg mb-2" data-id="element-154">
                  HOY SOLO:
                </p>
                <p className="text-6xl font-extrabold text-blue-600" data-id="element-155">
                  USD $12,99
                </p>
              </div>
              <p className="text-sm text-gray-500 mt-3" data-id="element-156">
                *Pagarás en la moneda de tu país
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8 text-sm" data-id="element-157">
              {['✔ Acceso inmediato', '✔ Un solo pago', '✔ Descarga digital', '✔ Acceso de por vida'].map(item => <div key={item} className="bg-white p-3 rounded-md font-medium text-gray-700" data-id="element-158">
                  {item}
                </div>)}
            </div>

            <CTAButton text="👉 OBTENER MI MEGAPACK HOY" fullWidth className="text-xl py-6 mb-4" data-id="element-159" />

            <div className="mt-6 bg-white p-4 rounded-lg border-2 border-blue-300" data-id="element-160">
              <div className="flex items-center justify-center gap-3" data-id="element-161">
                <Shield className="w-8 h-8 text-blue-600" data-id="element-162" />
                <div className="text-left" data-id="element-163">
                  <p className="font-bold text-gray-900" data-id="element-164">Garantía sin riesgo</p>
                  <p className="text-sm text-gray-600" data-id="element-165">
                    Probalo durante 7 días. Si no es para vos, te devolvemos el
                    100% del dinero.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-blue-50" data-id="element-166">
        <div className="max-w-6xl mx-auto" data-id="element-167">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-168">
            Lo que dicen otros docentes
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-169">
            {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-lg shadow-md" data-id="element-170">
                <div className="flex gap-1 mb-4 text-yellow-400" data-id="element-171">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-current" data-id="element-172" />)}
                </div>
                <p className="text-gray-700 italic mb-4" data-id="element-173">"{t.content}"</p>
                <p className="font-bold text-gray-900" data-id="element-174">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-175">
                  {t.role}, {t.location}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-white" data-id="element-176">
        <div className="max-w-3xl mx-auto" data-id="element-177">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-178">
            Preguntas frecuentes
          </h2>
          <div className="space-y-4" data-id="element-179">
            {faqs.map((faq, idx) => <div key={idx} className="bg-blue-50 rounded-lg p-6" data-id="element-180">
                <h3 className="font-bold text-lg text-gray-900 mb-2" data-id="element-181">
                  {faq.q}
                </h3>
                <p className="text-gray-700" data-id="element-182">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-183">
        <div className="max-w-4xl mx-auto" data-id="element-184">
          <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-185">
            Enseñar Matemática puede ser más simple
          </h2>
          <p className="text-xl mb-8" data-id="element-186">
            No necesitás más material. Necesitás un sistema que te sostenga todo
            el año.
          </p>
          <CTAButton text="👉 Accedé ahora al MegaPack Matemática Lista" className="text-xl px-12 py-6" data-id="element-187" />
        </div>
      </section>

      <footer className="bg-black text-gray-400 py-8 px-4 text-center text-sm" data-id="element-188">
        <div className="max-w-6xl mx-auto" data-id="element-189">
          <p data-id="element-190">
            &copy; 2026 MegaPack Matemática Lista. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-191">Privacidad · Términos y Condiciones</p>
        </div>
      </footer>
    </div>;
}